//@flow
import React from 'react';

import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';
import { bulkHomebaseFetch as bulkHomebaseFetchApi } from 'common/middleware/api';
import EntityIdInput from 'common/entity/generic/EntityIdInput';
import type { MasterHomebaseModelType } from 'common/models/flow/MasterHomebase';
import type { FilterModelType } from 'common/models/flow/Filter';

type Props = {
    isMulti?: boolean,
    clientId: string,
    disabled?: boolean,
    onChange: (
        ?MasterHomebaseModelType | Array<MasterHomebaseModelType>
    ) => void,
    value: ?MasterHomebaseModelType | Array<MasterHomebaseModelType>,
    homebaseInputFilters: (input: string) => Array<FilterModelType>,
    placeholder: string,
    popOverContent?: string,
    isPopOverOpen?: boolean
};

type State = {
    homebases: Array<MasterHomebaseModelType>
};

type PaginationInfoDataType = {
    currentPage: number,
    numberOfPages: number,
    total: number
};

type HomebasesDataType = {
    homebases: Array<MasterHomebaseModelType>,
    paginationInfo: PaginationInfoDataType
};

class HomebaseIdInput extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            homebases: []
        };
        this.loadHomebaseOptions = debounce(this.loadHomebaseOptions, 200);
    }

    componentWillUnmount() {
        this.loadHomebaseOptions.cancel();
    }

    loadHomebaseOptions = (input: string, callback) => {
        const { clientId, homebaseInputFilters } = this.props;
        const filters = homebaseInputFilters(input);
        bulkHomebaseFetchApi
            .post({ clientId }, { filters })
            .then((response: HomebasesDataType) => {
                const { homebases } = response;
                this.setState({ homebases });
                callback(homebases);
            })
            .catch(() => {
                //Ignore the error
            });
    };

    onChange = (
        value: ?MasterHomebaseModelType | Array<MasterHomebaseModelType>
    ) => {
        const { onChange } = this.props;
        onChange(value);
    };

    render() {
        const { homebases } = this.state;
        const {
            value,
            placeholder,
            popOverContent,
            isPopOverOpen,
            isMulti = false,
            disabled = false
        } = this.props;
        return (
            <EntityIdInput
                isMulti={isMulti}
                disabled={disabled}
                onChange={this.onChange}
                options={homebases}
                value={value}
                loadOptions={this.loadHomebaseOptions}
                placeholder={placeholder}
                popOverContent={popOverContent}
                isPopOverOpen={isPopOverOpen}
            />
        );
    }
}

export default translate('entityManagement')(HomebaseIdInput);
